import { createAsyncThunk } from '@reduxjs/toolkit';
import peopleActivitiesAPI from '@infrastructure/people-activities-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getCurrentMonthActivitiesAsync = createAsyncThunk('peopleActivities/getCurrentMonth', async (CompanyId, { rejectWithValue }) => {
    try {
        const response = await peopleActivitiesAPI.getCurrentMonthActivities(CompanyId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPeopleActivitiesDashboardAsync = createAsyncThunk('peopleActivities/getDashboard', async (CompanyId, { rejectWithValue }) => {
    try {
        const response = await peopleActivitiesAPI.getPeopleActivitiesDashboard(CompanyId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getActivityByIdAsync = createAsyncThunk('peopleActivities/getById', async (activityId, { rejectWithValue }) => {
    try {
        const response = await peopleActivitiesAPI.getActivityById(activityId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPeopleMonthlyActivitiesForDashboardsAndCalendarAsync = createAsyncThunk('peopleActivities/getMonthlyActivitiesForDashboardsAndCalendar', async (query, { rejectWithValue }) => {
    try {
        const response = await peopleActivitiesAPI.getPeopleMonthlyActivitiesForDashboardsAndCalendar(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPeopleActivitiesByPersonIdAsync = createAsyncThunk('peopleActivities/getByPersonId', async (personId, { rejectWithValue }) => {
    try {
        const response = await peopleActivitiesAPI.getPeopleActivitiesByPersonId(personId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
